import * as React from 'react';
import KeyboardShortcutsFull from './view/KeyboardShortcutsFull';
import isKeyboardShortcutsOptionDirty from './utils/isKeyboardShortcutsOptionDirty';
import discardKeyboardShortcutsOption from './data/mutators/discardKeyboardShortcutsOption';
import saveKeyboardShortcutsOption from './orchestration/saveKeyboardShortcutsOption';
var KeyboardShortcutsOption = {
    key: 'shortcuts',
    titleStringKey: 'optionTitle_shortcuts',
    searchTermsStringKey: 'optionTitle_shortcuts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(KeyboardShortcutsFull, null); },
        isDirty: isKeyboardShortcutsOptionDirty,
        onSave: saveKeyboardShortcutsOption,
        onDiscard: discardKeyboardShortcutsOption,
    },
};
export default KeyboardShortcutsOption;
//# sourceMappingURL=KeyboardShortcutsOption.js.map